module.exports = __webpack_public_path__ + "static/src/content/images/processed/thumbBlurLarge/Syriana.0342e30.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/content/images/processed/thumbBlurLarge/Syriana.jpg
// module id = d+oa
// module chunks = 0